// function pageGetPath() {
//     const desiredPath = "https://rumicosmetiques.com/pages/early-bfcm-2025";
//     const currentUrl = window.location.href;
//     if (currentUrl !== desiredPath) {
//       window.history.pushState({}, "", desiredPath);
//     }
// }

// setInterval(() => {
//     pageGetPath();
// }, 10);

function scrollFun(){
  if (window.scrollY > 200) {
      document.querySelector('.bfcm_timer').classList.add('active');
    } else {
      document.querySelector('.bfcm_timer').classList.remove('active');
    }
}

document.addEventListener("DOMContentLoaded", (event) => {

  pageGetPath();

  scrollFun();
});
window.addEventListener('scroll', function() {
  scrollFun();
});


/*
const countdownEl = document.getElementById("bfcm_countdown");
const dataEl = document.getElementById("bfcm_timer-data");
const endStr = dataEl.getAttribute("data-end");
function parseDateTime(str) {
  const [datePart, timePart] = str.split(":");
  const [day, month, year] = datePart.split("/").map(Number);

  const match = str.match(/(\d{2}):(\d{2}):(\d{2})(AM|PM)/i);
  if (!match) return null;

  let [_, hh, mm, ss, meridian] = match;
  let hours = parseInt(hh, 10);
  const minutes = parseInt(mm, 10);
  const seconds = parseInt(ss, 10);
  if (meridian.toUpperCase() === "PM" && hours < 12) hours += 12;
  if (meridian.toUpperCase() === "AM" && hours === 12) hours = 0;
  return new Date(year, month - 1, day, hours, minutes, seconds);
}

const endDate = parseDateTime(endStr);

function updateCountdown() {
  const now = new Date().getTime();
  const distance = endDate.getTime() - now;

  if (distance <= 0) {
    countdownEl.innerHTML = "00 : 00 : 00";
    return;
  }

  const totalHours = Math.floor(distance / (1000 * 60 * 60));
  const minutes = Math.floor((distance / (1000 * 60)) % 60);
  const seconds = Math.floor((distance / 1000) % 60);

  document.getElementById("bfcm_hours").textContent = String(totalHours).padStart(2, "0");
  document.getElementById("bfcm_minutes").textContent = String(minutes).padStart(2, "0");
  document.getElementById("bfcm_seconds").textContent = String(seconds).padStart(2, "0");
}

setInterval(updateCountdown, 1000);
updateCountdown();

*/

  const hoursEl = document.getElementById("bfcm_hours");
  const minutesEl = document.getElementById("bfcm_minutes");
  const secondsEl = document.getElementById("bfcm_seconds");

  // --- CONFIG ---
  const startHour = 0;  // 0 = midnight
  const endHour = 24;   // countdown ends at 24h (next midnight)
  // You can make it 23 for a 23-hour window or any custom time frame

  function getTodayEndTime() {
    const now = new Date();
    const end = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      endHour, 0, 0, 0
    );
    // If it's already past endHour, set end time to tomorrow's endHour
    if (now >= end) {
      end.setDate(end.getDate() + 1);
    }
    return end;
  }

  let endTime = getTodayEndTime();

  function updateCountdown() {
    const now = new Date();
    const distance = endTime - now;

    // If the countdown ended, reset for the next day
    if (distance <= 0) {
      endTime = getTodayEndTime();
    }

    const totalHours = Math.floor((distance / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((distance / (1000 * 60)) % 60);
    const seconds = Math.floor((distance / 1000) % 60);

    hoursEl.textContent = String(totalHours).padStart(2, "0");
    minutesEl.textContent = String(minutes).padStart(2, "0");
    secondsEl.textContent = String(seconds).padStart(2, "0");
  }

  setInterval(updateCountdown, 1000);
  updateCountdown();